package io.horion.cv.sections

import androidx.compose.runtime.Composable
import androidx.compose.runtime.LaunchedEffect
import androidx.compose.runtime.getValue
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.remember
import androidx.compose.runtime.setValue
import androidx.compose.web.events.SyntheticMouseEvent
import com.varabyte.kobweb.compose.css.Cursor
import com.varabyte.kobweb.compose.css.FontWeight
import com.varabyte.kobweb.compose.css.Overflow
import com.varabyte.kobweb.compose.css.ScrollBehavior
import com.varabyte.kobweb.compose.css.TextAlign
import com.varabyte.kobweb.compose.css.WhiteSpace
import com.varabyte.kobweb.compose.foundation.layout.Arrangement
import com.varabyte.kobweb.compose.foundation.layout.Box
import com.varabyte.kobweb.compose.foundation.layout.Column
import com.varabyte.kobweb.compose.foundation.layout.Row
import com.varabyte.kobweb.compose.foundation.layout.Spacer
import com.varabyte.kobweb.compose.ui.Alignment
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.graphics.Color
import com.varabyte.kobweb.compose.ui.modifiers.alignItems
import com.varabyte.kobweb.compose.ui.modifiers.backgroundColor
import com.varabyte.kobweb.compose.ui.modifiers.borderRadius
import com.varabyte.kobweb.compose.ui.modifiers.color
import com.varabyte.kobweb.compose.ui.modifiers.cursor
import com.varabyte.kobweb.compose.ui.modifiers.display
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxWidth
import com.varabyte.kobweb.compose.ui.modifiers.fontFamily
import com.varabyte.kobweb.compose.ui.modifiers.fontWeight
import com.varabyte.kobweb.compose.ui.modifiers.gap
import com.varabyte.kobweb.compose.ui.modifiers.justifyContent
import com.varabyte.kobweb.compose.ui.modifiers.margin
import com.varabyte.kobweb.compose.ui.modifiers.maxWidth
import com.varabyte.kobweb.compose.ui.modifiers.onClick
import com.varabyte.kobweb.compose.ui.modifiers.onMouseEnter
import com.varabyte.kobweb.compose.ui.modifiers.onMouseLeave
import com.varabyte.kobweb.compose.ui.modifiers.overflow
import com.varabyte.kobweb.compose.ui.modifiers.padding
import com.varabyte.kobweb.compose.ui.modifiers.position
import com.varabyte.kobweb.compose.ui.modifiers.scrollBehavior
import com.varabyte.kobweb.compose.ui.modifiers.textAlign
import com.varabyte.kobweb.compose.ui.modifiers.whiteSpace
import com.varabyte.kobweb.compose.ui.modifiers.width
import com.varabyte.kobweb.compose.ui.styleModifier
import com.varabyte.kobweb.core.rememberPageContext
import com.varabyte.kobweb.framework.annotations.DelicateApi
import com.varabyte.kobweb.silk.components.forms.Button
import com.varabyte.kobweb.silk.components.graphics.Image
import com.varabyte.kobweb.silk.components.icons.fa.FaArrowRight
import com.varabyte.kobweb.silk.components.icons.fa.FaChevronLeft
import com.varabyte.kobweb.silk.components.icons.fa.FaChevronRight
import com.varabyte.kobweb.silk.components.text.SpanText
import com.varabyte.kobweb.silk.style.toModifier
import com.varabyte.kobweb.silk.theme.colors.ColorMode
import io.horion.cv.models.CvData
import io.horion.cv.pages.navigation.Screen
import io.horion.cv.styles.ArrowImageStyle
import io.horion.cv.styles.CarouselWrapperStyle
import io.horion.cv.styles.ChevronButtonLeftPositionStyle
import io.horion.cv.styles.ChevronButtonRightPositionStyle
import io.horion.cv.styles.ChevronButtonStyle
import io.horion.cv.styles.ChevronImageStyle
import io.horion.cv.styles.CoverLetterSectionStyle
import io.horion.cv.styles.DesktopCarouselContainerStyle
import io.horion.cv.styles.MeatballContainerStyle
import io.horion.cv.styles.MeatballDotStyle
import io.horion.cv.styles.MeatballRowStyle
import io.horion.cv.styles.MobileCarouselContainerStyle
import io.horion.cv.styles.ModelImageStyle
import io.horion.cv.styles.ModelSectionStyle
import io.horion.cv.styles.ModelSectionTitleStyle
import io.horion.cv.styles.ViewButtonArrowStyle
import io.horion.cv.styles.ViewButtonBaseStyle
import io.horion.cv.styles.ViewButtonLabelLongStyle
import io.horion.cv.styles.ViewButtonLabelShortStyle
import io.horion.cv.utils.Colors
import io.horion.cv.utils.Constants.POPPINS
import io.horion.cv.utils.Constants.UBUNTU
import kotlinx.coroutines.delay
import org.jetbrains.compose.web.css.AlignItems
import org.jetbrains.compose.web.css.DisplayStyle
import org.jetbrains.compose.web.css.JustifyContent
import org.jetbrains.compose.web.css.Position
import org.jetbrains.compose.web.css.percent
import org.jetbrains.compose.web.css.px
import kotlin.time.Duration.Companion.milliseconds


private fun imagesForDesktopPage(page: Int): List<String> {
    val values = CvData.cvList.values.toList()
    return when (page) {
        0 -> values.slice(0..1)
        1 -> values.slice(2..3)
        2 -> values.slice(4..5)
        else -> emptyList()
    }
}


@Composable
fun ModelSection() {
    val ctx = rememberPageContext()
    val colorMode by ColorMode.currentState
    val isDark = colorMode.isDark
    val sectionBg = if (isDark) Colors.holder else Colors.LighterBlue.copy(alpha = 10)

    Column(
        modifier = ModelSectionStyle.toModifier()
            .backgroundColor(sectionBg)
            .fillMaxWidth(),
        horizontalAlignment = Alignment.CenterHorizontally
    ) {
        SpanText(
            "Optez pour le modèle\n" +
                    "qui vous correspond et commencez",
            modifier = ModelSectionTitleStyle.toModifier()
                .fontFamily(POPPINS)
                .fontWeight(FontWeight.SemiBold)
                .color(Colors.DarkBlue)
                .whiteSpace(WhiteSpace.PreWrap)
                .textAlign(TextAlign.Center)
        )

        CvCarousel()

        Box(
            modifier = ViewButtonBaseStyle.toModifier()
        ) {
            ViewButton(
                onClick = { ctx.router.navigateTo(Screen.CV.path) },
            )
        }

    }
}

@Composable
fun CvCarousel() {
    Column(
        modifier = Modifier.fillMaxWidth(),
        horizontalAlignment = Alignment.CenterHorizontally
    ) {
        // Version Mobile (1 carte par slide)
        Box(modifier = MobileCarouselContainerStyle.toModifier().fillMaxWidth()) {
            SingleItemCarousel()
        }

        // Version Desktop (Grille/Groupe de cartes par slide)
        Box(modifier = DesktopCarouselContainerStyle.toModifier().fillMaxWidth()) {
            PairedItemCarousel()
        }
    }
}

@OptIn(DelicateApi::class)
@Composable
private fun SingleItemCarousel() {
    val allImages = CvData.cvList.values.toList()
    val pageCount = allImages.size

    var page by remember { mutableStateOf(0) }
    var targetPage by remember { mutableStateOf(0) }
    var animating by remember { mutableStateOf(false) }

    Column(
        modifier = Modifier.fillMaxWidth(),
        horizontalAlignment = Alignment.CenterHorizontally
    ) {
        Box(
            modifier = CarouselWrapperStyle.toModifier()
                .fillMaxWidth()
                .maxWidth(1200.px)
                .position(Position.Relative)
                .overflow(Overflow.Hidden),
            contentAlignment = Alignment.Center
        ) {
            if (page > 0) {
                ChevronButton(left = true) {
                    if (!animating) {
                        targetPage = page - 1
                        animating = true
                    }
                }
            }

            Box(modifier = Modifier.width(100.percent).overflow(Overflow.Hidden)) {
                Row(
                    modifier = Modifier
                        .width((pageCount * 100).percent)
                        .styleModifier {
                            property("transform", "translateX(-${targetPage * (100.0 / pageCount)}%)")
                            property("transition", "transform 400ms ease")
                        }
                ) {
                    allImages.forEach { src ->
                        Box(
                            modifier = Modifier
                                .width((100.0 / pageCount).percent)
                                .padding(leftRight = 20.px),
                            contentAlignment = Alignment.Center
                        ) {
                            CvCard(src)
                        }
                    }
                }
            }

            if (page < pageCount - 1) {
                ChevronButton(left = false) {
                    if (!animating) {
                        targetPage = page + 1
                        animating = true
                    }
                }
            }
        }

        Spacer()

        Box(
            modifier = MeatballContainerStyle.toModifier()
                .borderRadius(50.px)
                .backgroundColor(Colors.GrayLight),
            contentAlignment = Alignment.Center
        ) {
            MeatballNavigation(
                page = page,
                count = pageCount,
                onClick = { clicked ->
                    if (!animating && clicked != page) {
                        targetPage = clicked
                        animating = true
                    }
                }
            )
        }
    }

    if (animating) {
        LaunchedEffect(targetPage) {
            delay(400.milliseconds)
            page = targetPage
            animating = false
        }
    }
}

@OptIn(DelicateApi::class)
@Composable
private fun PairedItemCarousel() {
    val pageCount = 3

    var page by remember { mutableStateOf(0) }
    var targetPage by remember { mutableStateOf(0) }
    var animating by remember { mutableStateOf(false) }

    Column(
        modifier = Modifier.fillMaxWidth(),
        horizontalAlignment = Alignment.CenterHorizontally
    ) {
        Box(
            modifier = CarouselWrapperStyle.toModifier()
                .fillMaxWidth()
                .maxWidth(1200.px)
                .position(Position.Relative)
                .overflow(Overflow.Hidden),
            contentAlignment = Alignment.Center
        ) {
            if (page > 0) {
                ChevronButton(left = true) {
                    if (!animating) {
                        targetPage = page - 1
                        animating = true
                    }
                }
            }

            Box(modifier = Modifier.width(100.percent).overflow(Overflow.Hidden)) {
                Row(
                    modifier = Modifier
                        .width((pageCount * 100).percent)
                        .styleModifier {
                            property("transform", "translateX(-${targetPage * (100.0 / pageCount)}%)")
                            property("transition", "transform 400ms ease")
                        }
                ) {
                    (0 until pageCount).forEach { index ->
                        Row(
                            modifier = Modifier.width((100.0 / pageCount).percent),
                            horizontalArrangement = Arrangement.spacedBy(20.px, Alignment.CenterHorizontally),
                            verticalAlignment = Alignment.CenterVertically
                        ) {
                            imagesForDesktopPage(index).forEach { CvCard(it) }
                        }
                    }
                }
            }

            if (page < pageCount - 1) {
                ChevronButton(left = false) {
                    if (!animating) {
                        targetPage = page + 1
                        animating = true
                    }
                }
            }
        }

        Spacer()

        Box(
            modifier = MeatballContainerStyle.toModifier()
                .borderRadius(50.px)
                .backgroundColor(Colors.GrayLight),
            contentAlignment = Alignment.Center
        ) {
            MeatballNavigation(
                page = page,
                count = pageCount,
                onClick = { clicked ->
                    if (!animating && clicked != page) {
                        targetPage = clicked
                        animating = true
                    }
                }
            )
        }
    }

    if (animating) {
        LaunchedEffect(targetPage) {
            delay(400.milliseconds)
            page = targetPage
            animating = false
        }
    }
}

@OptIn(DelicateApi::class)
@Composable
fun ChevronButton(
    left: Boolean,
    onClick: () -> Unit
) {
    val iconFilter = "invert(1)"

    Box(
        modifier = ChevronButtonStyle.toModifier()
            .borderRadius(40.px)
            .cursor(Cursor.Pointer)
            .backgroundColor(Colors.LighterBlue)
            .position(Position.Absolute)
            .styleModifier { property("z-index", "10") }
            .then(if (left) ChevronButtonLeftPositionStyle.toModifier() else ChevronButtonRightPositionStyle.toModifier())
            .onClick { onClick() },
        contentAlignment = Alignment.Center
    ) {

        if (left) {

            FaChevronLeft(
                modifier = ChevronImageStyle
                    .toModifier()
                    .styleModifier { property("filter", iconFilter)},
            )

        } else {
            FaChevronRight(
                modifier = ChevronImageStyle
                    .toModifier()
                    .styleModifier { property("filter", iconFilter)},
            )
        }
    }
}


@OptIn(DelicateApi::class)
@Composable
fun MeatballNavigation(
    page: Int,
    count: Int,
    onClick: (Int) -> Unit
) {
    Row(
        modifier = MeatballRowStyle.toModifier(),
        horizontalArrangement = Arrangement.Center,
        verticalAlignment = Alignment.CenterVertically
    ) {
        repeat(count) { index ->
            Box(
                modifier = MeatballDotStyle.toModifier()
                    .borderRadius(50.px)
                    .backgroundColor(if (index == page) Colors.White else Colors.LightGray)
                    .cursor(Cursor.Pointer)
                    .onClick { onClick(index) }
            )
        }
    }
}

@OptIn(DelicateApi::class)
@Composable
fun ViewButton(
    onClick: (SyntheticMouseEvent) -> Unit,
    modifier: Modifier = Modifier,
) {
    var isHovered by remember { mutableStateOf(false) }

    Button(
        onClick = onClick,
        modifier = modifier
            .then(CoverLetterSectionStyle.toModifier())
            .borderRadius(44.px)
            .fontFamily(UBUNTU)
            .fontWeight(FontWeight.Normal)
            .display(DisplayStyle.Flex)
            .alignItems(AlignItems.Center)
            .justifyContent(JustifyContent.Center)
            .gap(0.px)
            .overflow(Overflow.Hidden)
            .onMouseEnter { isHovered = true }
            .onMouseLeave { isHovered = false }
    ) {
        SpanText("Voir les modèles", modifier = ViewButtonLabelShortStyle.toModifier())
        SpanText("Voir les modèles de CV", modifier = ViewButtonLabelLongStyle.toModifier())

        FaArrowRight(
            modifier = ArrowImageStyle.toModifier()
                .color(if (isHovered) Color.rgb(0x00, 0xd5, 0xe1) else Colors.White)
                .then(ViewButtonArrowStyle.toModifier())
        )
    }
}


@Composable
fun CvCard(src: String) {
    Box(
        modifier = Modifier
            .overflow(Overflow.Visible)
            .padding(5.px)
            .margin(bottom = 10.px)
            .cursor(Cursor.Pointer)
            .scrollBehavior(ScrollBehavior.Smooth),
        contentAlignment = Alignment.Center
    ) {
        Image(
            src = src,
            description = "CV card",
            modifier = ModelImageStyle.toModifier()
        )
    }
}